import GameSignals from '@/signals/GameSignals'
import { toMoney } from '@base/utils/Formatter'
import gsap from 'gsap'
import Facade from '@/Facade'
import { toMajorUnits } from '@/utils/CurrencyUnits'
import { capWinIncrement } from '@/states/round/MaxWinCap'

export class WinCounter {
    public static readonly DURATION: number = 0.5
    public static readonly EASING: string = 'power2.out'

    private _lastTween: gsap.core.Tween
    private _counteredWin: number
    private _totalWin: number

    public constructor() {
        this._lastTween = null
        this._reset()
    }

    public countWin(value: number, duration: number = -1, force: boolean = false, onComplete: Function = null): void {
        if (value < 0) {
            // no need to count incorrect wins
            return
        }

        if (value === 0 && !force) {
            // no need to count zero wins
            return
        }

        value = capWinIncrement(Facade.model, this._totalWin, value)

        if (value <= 0 && !force) {
            return
        }

        const counter = { value: this._counteredWin }
        this._totalWin += value

        if (duration === -1) {
            duration = WinCounter.DURATION
        }

        if (this._lastTween) {
            this._lastTween.kill()
            this._lastTween = null
        }

        this._lastTween = gsap.to(
            counter, duration, {
                ease: WinCounter.EASING,
                value: this._totalWin,
                onUpdate: () => {
                    GameSignals.updateUIWinField.emit(toMoney(toMajorUnits(counter.value), 2))
                    this._counteredWin = counter.value
                },
                onComplete: () => {
                    this._lastTween = null
                    if (onComplete) {
                        onComplete()
                    }
                },
            },
        )
    }

    private _reset = () => {
        this._counteredWin = 0
        this._totalWin = 0
    }

    public startRound(): void {
        this._reset()
    }

    public stopRound(): void {
        if (this._totalWin > 0) {
            GameSignals.updateUIWinField.emit(toMoney(toMajorUnits(this._totalWin), 2))
        }
    }

    public get totalWin(): number {
        return this._totalWin
    }
}
